module.exports = __webpack_public_path__ + "static/assets/ed4d94180f676977ed7267cc7f71065d.png";